import { axiosPrivate } from "../../api/axios";
import handleError from "../../hooks/handleError";


// Save Accounts ("Save Changes")
const saveConnectedAccounts = (Connected_Accounts) => {

    let isMounted = true;
    const controller = new AbortController();

    const ConnAccountsToInsert = Connected_Accounts.filter((row) => row.actions === "INSERT");
    const ConnAccountsToUpdate = Connected_Accounts.filter((row) => row.actions === "UPDATE");
    const ConnAccountsToDelete = Connected_Accounts.filter((row) => row.actions === "DELETE");

    const insertConnectedAccounts = async (ConnAccountsToInsert) => {
        try {
            await axiosPrivate.post("/Settings/create/connected-accounts",
                ConnAccountsToInsert,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const updateConnectedAccounts = async (ConnAccountsToUpdate) => {
        try {
            await axiosPrivate.put("/Settings/update/connected-accounts",
                ConnAccountsToUpdate,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const deleteConnectedAccounts = async (ConnAccountsToDelete) => {
        try {
            await axiosPrivate.post("/Settings/delete/connected-accounts",
                ConnAccountsToDelete,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    if (ConnAccountsToDelete.length > 0) { deleteConnectedAccounts(ConnAccountsToDelete) };
    if (ConnAccountsToInsert.length > 0) { insertConnectedAccounts(ConnAccountsToInsert) };
    if (ConnAccountsToUpdate.length > 0) { updateConnectedAccounts(ConnAccountsToUpdate) };

};
export default saveConnectedAccounts